import merge from 'deepmerge';
import base from './base';

/**
 * Production environment configuration
 */
export default merge.all([base, {

  //CMS
  cms: {
    baseUrl: 'https://cms.morble.co',
  },

  //API
  api: {
    baseUrl: 'https://morble.herokuapp.com',
  },

  //App
  app: {
    baseUrl: 'https://app.morble.co',
  },

  //Sentry
  sentry: {
    dsn: `https://8ce8e91617004ee4bfd5c294497cc30e@sentry.io/1328204`,
  },
}]);
